import { type SVGProps } from "react"

export function Connector2(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={136}
            height={116}
            fill="none"
            {...props}
        >
            <path
                fill="azure"
                fillRule="evenodd"
                d="M134 0a2 2 0 0 1 2 2v6.48a2 2 0 1 1-4 0V2a2 2 0 0 1 2-2Zm0 15.12a2 2 0 0 1 2 2v12.96a2 2 0 1 1-4 0V17.12a2 2 0 0 1 2-2Zm0 21.6a2 2 0 0 1 2 2v12.96a2 2 0 1 1-4 0V38.72a2 2 0 0 1 2-2Zm0 21.6a2 2 0 0 1 2 2v12.96a2 2 0 1 1-4 0V60.32a2 2 0 0 1 2-2Zm0 21.6a2 2 0 0 1 2 2v12.96a2 2 0 1 1-4 0V81.92a2 2 0 0 1 2-2Zm0 21.6a2 2 0 0 1 2 2V112h-7.65a2 2 0 1 1 0-4H132v-4.48a2 2 0 0 1 2-2ZM19 110a2 2 0 0 1 2-2h5.65a2 2 0 1 1 0 4H21a2 2 0 0 1-2-2Zm13.183 0a2 2 0 0 1 2-2h11.3a2 2 0 1 1 0 4h-11.3a2 2 0 0 1-2-2Zm18.834 0a2 2 0 0 1 2-2h11.3a2 2 0 1 1 0 4h-11.3a2 2 0 0 1-2-2Zm18.833 0a2 2 0 0 1 2-2h11.3a2 2 0 1 1 0 4h-11.3a2 2 0 0 1-2-2Zm18.833 0a2 2 0 0 1 2-2h11.3a2 2 0 1 1 0 4h-11.3a2 2 0 0 1-2-2Zm18.834 0a2 2 0 0 1 2-2h11.3a2 2 0 0 1 0 4h-11.3a2 2 0 0 1-2-2Z"
                clipRule="evenodd"
            />
            <circle
                cx={6}
                cy={110}
                r={6}
                fill="#FF2FFB"
            />
        </svg>
    )
}
